import SubjectIcon from "@/app/components/logos/SubjectIcon";
import { getSubjectColorIndex } from "@/lib/strapi/formatters";
import { NavLink } from "@mantine/core";
import { stripSubjectFromYear, titleToUrl } from "@utils/routing";
import clsx from "clsx";
import Link from "next/link";
import { CSSProperties, Dispatch, SetStateAction } from "react";
import classes from "./SubjectLinks.module.css";

export default function SubjectLinks({
  subjectName,
  opened,
  setOpened,
}: {
  subjectName: string;
  opened: boolean;
  setOpened: Dispatch<SetStateAction<boolean>>;
}) {
  const subjectColorIndex = getSubjectColorIndex(subjectName);
  const subjectSlug = titleToUrl(subjectName);
  const isNew = subjectName.includes("2025");
  const iconStyle = {
    "--icon-before-bg": `var(--mantine-color-${subjectColorIndex}-6)`,
  } as CSSProperties;
  return (
    <NavLink
      className={classes.overallLink}
      component={Link}
      href={`/ib/${subjectSlug}`}
      label={subjectName}
      aria-label={subjectName}
      leftSection={
        <SubjectIcon
          className={clsx(classes.iconWrapper, isNew && classes.iconWrapperNew)}
          subjectColorIndex={subjectColorIndex}
          style={iconStyle}
        />
      }
      onClick={() => {
        opened && setOpened(false);
      }}
    />
  );
}

export const useMenuStles = () => ({ classes });
